import {ThemeType} from 'grommet'
import {css} from 'styled-components'

import colors from './variables/colors'
import breakpoints from './variables/breakpoints'

// deepMerge(grommet,
// import { deepMerge } from 'grommet/utils';
// https://theme-designer.grommet.io/Dashboard

const buttonPadding = {
  horizontal: '12px',
  vertical: '5px',
}

const buttonOutline = (color: string) => {
  const colorSettings = colors[color]
  const shadow = '0 0 0 1px'

  if (!colorSettings) return
  if (typeof colorSettings === 'string') return `${shadow} ${colorSettings}`

  return `${shadow} ${colorSettings.light}`
}

export const defaultTheme: ThemeType = {
  grommet: {
    extend: css`
      min-height: 100vh;
    `,
  },
  global: {
    colors,
    breakpoints,
    font: {
      family: '"futura-pt", sans-serif',
      size: '12px',
      height: '16px',
      weight: 400,
    },
    // titles: {
    //   family: '"paralucent", "Roboto", "sans-serif"',
    //   size: '14px',
    //   height: '20px',
    //   weight: '400'
    // },
  },
  button: {
    transition: {
      timing: 'ease',
      duration: 0.5,
      properties: ['box-shadow'],
    },
    border: {
      width: '2px',
    },
    default: {
      color: 'text',
      border: {color: 'brand', width: '2px'},
      padding: buttonPadding,
    },
    primary: {
      background: {color: 'brand'},
      border: {color: 'brand', width: '2px'},
      color: 'white',
      padding: buttonPadding,
      font: {weight: '600'},
      extend: css`
        text-shadow: '1px 1px 1px rgba(0, 0, 0, 0.3)';
      `,
    },
    secondary: {
      border: {color: 'accent-1', width: '2px'},
      padding: buttonPadding,
    },
    hover: {
      padding: buttonPadding,
      default: {
        extend: css`
          box-shadow: ${buttonOutline('brand')};
        `,
      },
      primary: {
        extend: css`
          box-shadow: ${buttonOutline('brand')};
        `,
      },
      secondary: {
        extend: css`
          box-shadow: ${buttonOutline('accent-1')};
        `,
      },
    },
  },
}
